import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  y: "2.12134",
  width: "3",
  height: "11",
  transform: "rotate(-45 0 2.12134)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "13.7783",
  y: "0.000244141",
  width: "3",
  height: "11",
  transform: "rotate(45 13.7783 0.000244141)"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  __name: 'arrow',
  props: {
  color: { type: String, default: "#1e1e1e" },
},
  setup(__props) {

// eslint-disable-next-line no-undef


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "16",
    height: "10",
    viewBox: "0 0 16 10",
    fill: __props.color,
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_4, 8, _hoisted_1))
}
}

})